// Lesson Widget Constants
// These values are shared between LessonWidget.vue and LessonWidgetCard.vue

export const LESSON_CARD_WIDTH_MOBILE = 328; // CSS width in LessonWidgetCard
export const LESSON_CARD_WIDTH_DESKTOP = 376; // CSS width in LessonWidgetCard
export const LESSON_CARD_GAP = 16; // Gap between cards in CSS

// Scroll width calculations (card width + gap for desktop, just card width for mobile)
export const LESSON_CARD_SCROLL_WIDTH_MOBILE = LESSON_CARD_WIDTH_MOBILE;
export const LESSON_CARD_SCROLL_WIDTH_DESKTOP = LESSON_CARD_WIDTH_DESKTOP + LESSON_CARD_GAP;

export const LESSON_FLASHCARD_IDS_TEMPLATE = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ];
